import React from 'react';
import { IconType } from 'react-icons';

interface Position {
  x: number;
  y: number;
}

interface Action<T> {
  name: string;
  icon: IconType;
  onClick: (rowData: T) => void;
}

interface ActionsBoxProps<T> {
  position: Position;
  theme?: any;
  actions: Action<T>[];
  rowData: T;
}

const ActionsMenu = <T,>({ position, theme, actions, rowData }: ActionsBoxProps<T>) => {
  const actionsBoxStyle: React.CSSProperties = {
    width: 'auto',
    height: 'auto',
    position: 'absolute',
    padding: '10px',
    borderRadius: '12px',
    gap: '5px',
    boxShadow: '0px 4px 3px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.table.style.backgroundColor,
    left: `${position?.x}px`,
    top: `${position?.y}px`,
    zIndex: 1,
  };

  const actionButton: React.CSSProperties = {
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '10px',
    minWidth: '125px',
    padding: '6px 12px 6px 12px',
    borderRadius: '8px',
    border: '1px solid #efefef',
    cursor: 'pointer',
  };

  return (
    <div id="actionsBox" style={actionsBoxStyle}>
      {actions.map((action, index) => (
        <button key={index} onClick={() => action.onClick(rowData)} style={actionButton}>
          {React.createElement(action.icon)}
          <span>{action.name}</span>
        </button>
      ))}
    </div>
  );
};

export default ActionsMenu;